export default __webpack_public_path__ + "static/media/refresh_dark.dfb2a85c.svg";